var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:[
    'v-header',
    {
      'v-header--with-image': !!_vm.imgSrc,
      'v-header--auto-height': !!_vm.autoHeight
    }
  ],style:({
    backgroundImage: !!_vm.imgSrc && ("url('" + _vm.imgSrc + "')"),
    backgroundPosition: !!_vm.imgAlign && _vm.imgAlign
  })},[_vm._t("navbar"),(_vm.hasContent)?_c('div',{class:['v-header__content', 'container-fluid', 'py-5']},[_vm._t("default")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }